<template>
  <div :key="refresh_key">
    <!-- *** IME **** -->
    <form-input
      :invalid="invalid_elements.ime"
      :label="$t('forms.person.phys_pers.name_lbl')"
      id="ime"
      ref="imeFiz"
      required="required"
      :base="fizicka.ime"
    ></form-input>
    <!-- *** Prezime **** -->
    <form-input
      :invalid="invalid_elements.prezime"
      :label="$t('forms.person.phys_pers.surname_lbl')"
      id="prezime"
      ref="prezimeFiz"
      required="required"
      :base="fizicka.prezime"
    ></form-input>
    <div class="events-date-time-wrapper">
      <!-- CIJELI DAN -->
      <form-checkbox
        class="checkbox"
        :id="'portal-user'"
        :name="'portal-user'"
        :label="$t('components.person.physical_person.active_client_portal')"
        ref="userPortalBool"
      ></form-checkbox>

      <form-input
        v-show="user_portal_create.value"
        :invalid="invalid_elements.username"
        :label="$t('components.person.physical_person.enter_login_email')"
        id="email"
        ref="usernameFiz"
        required="required"
        :base="fizicka.username"
        style="width: 35rem"
      ></form-input>
    </div>
    <div class="form-input-wrapper" v-show="user_portal_create.value">
      <label class="form-label" for="datum-eot">
        <span>{{ $t("forms.person.phys_pers.cp_eot") }}</span>
      </label>
      <div>
        <input
          class="form-input"
          type="date"
          id="datum-eot"
          ref="datumEot"
          name="datum-eot"
          @input="fizicka.eot = $event.target.value"
          v-model="fizicka.eot"
        />
      </div>
    </div>
    <!-- OIB -->
    <form-input
      :label="$t('forms.person.phys_pers.oib')"
      id="oib"
      ref="OIB"
      :base="fizicka.oib"
    ></form-input>
    <div class="form-input-wrapper">
      <label class="form-label" for="datum-rodjenja">
        <span>{{ $t("forms.person.phys_pers.date") }}</span>
      </label>
      <div>
        <input
          class="form-input"
          type="date"
          id="datum-rodjenja"
          ref="datumRodjenja"
          name="datum-rodjenja"
          @input="fizicka.rodjendan = $event.target.value"
          v-model="fizicka.rodjendan"
        />
      </div>
    </div>

    <!-- *** Email *** -->
    <form-input-multiple
      ref="email"
      :name="'email'"
      :label="$t('forms.person.phys_pers.email_lbl')"
      :placeholder="$t('forms.person.phys_pers.email_plh')"
      :base="fizicka.email_list"
    />
    <!-- *** Broj telefona *** -->
    <form-input-multiple
      ref="telefon"
      :name="'telefon'"
      :label="$t('forms.person.phys_pers.tel_lbl')"
      :placeholder="$t('forms.person.phys_pers.tel_plh')"
      :base="fizicka.tel_br_list"
    />
    <!-- *** Web stranica *** -->
    <form-input-multiple
      ref="stranica"
      :name="'stranica'"
      :label="$t('forms.person.phys_pers.web_lbl')"
      :placeholder="$t('forms.person.phys_pers.web_plh')"
      :base="fizicka.web_list"
    />

    <div class="form-divider"></div>
    <adresa-element ref="adresaElement" :base="fizicka.adrese_list" />

    <div class="form-divider"></div>
    <!-- *** INDUSTRIJA **** -->
    <form-drop-down
      :label="$t('forms.person.phys_pers.indust_lbl')"
      id="industrija"
      ref="industrija"
      :dropImport="industrija"
      :base="fizicka.industrija_id.ID"
    ></form-drop-down>

    <!-- *** Godišnji prihod **** -->
    <form-input
      :label="$t('forms.person.phys_pers.prihod_lbl')"
      id="godisnji-prihod"
      ref="godisnjiPrihod"
      :base="fizicka.god_prihod"
    ></form-input>
    <!-- <form-autocomplete-single
      :style="crm === true ? 'display:flex' : 'display:none'"
      label="Zadužena osoba"
      type="clanovi_tima"
      id="clanovi-tima-eventi"
      ref="teamLead"
      placeholder="Odaberite članove tima"
      :items="clanovi"
    ></form-autocomplete-single> -->

    <!-- *** Tip izvora **** -->
    <form-drop-down
      :label="$t('forms.person.phys_pers.tip_izvora')"
      id="tip-izvor"
      ref="tipIzvor"
      :dropImport="tipovi_izvora"
      :base="fizicka.id_tip_izvora.ID"
    ></form-drop-down>
    <form-autocomplete-single
      :invalid="invalid_elements.izvor"
      :style="fizicka.id_tip_izvora.ID < 3 ? 'display:flex' : 'display:none'"
      :name="'imeIzvora'"
      :start="
        fizicka.id_tip_izvora.ID == 1
          ? fizicka.izvor_fizicka_osoba
          : fizicka.izvor_pravna_osoba
      "
      :placeholder="
        fizicka.id_tip_izvora.ID == 1
          ? $t('forms.person.phys_pers.izvor1')
          : $t('forms.person.phys_pers.izvor2')
      "
      :type="'Izvor'"
      :id="'izvor'"
      ref="imeIzvora"
      :items="fizicka.id_tip_izvora.ID == 1 ? fizicke : pravne"
    ></form-autocomplete-single>
    <form-autocomplete
      :style="fizicka.id_tip_izvora.ID == 3 ? 'display:flex' : 'display:none'"
      :label="$t('forms.person.phys_pers.members_lbl')"
      type="clanovi_tima"
      id="clanovi-tima-eventi"
      ref="clanoviTima"
      placeholder="Odaberite članove tima"
      :items="clanovi"
    >
    </form-autocomplete>
    <!-- *** Izvor izvan sustava **** -->
    <form-input
      :invalid="invalid_elements.custom_ime_izvora"
      :style="fizicka.id_tip_izvora.ID == 4 ? 'display:flex' : 'display:none'"
      :label="$t('forms.person.phys_pers.custom_lbl')"
      id="custom-izvor"
      ref="customIzvor"
      :base="fizicka.custom_ime_izvora"
    ></form-input>
    <!-- *** Drugi kontakt ****
    <form-input
      label="Drugi kontakt"
      id="drugi-kontakt"
      ref="drugiKontakt"
    ></form-input> -->
    <!-- *** Radno vrijeme **** -->
    <form-input
      :label="$t('forms.person.phys_pers.radno_lbl')"
      id="radno-vrijeme"
      ref="radnoVrijeme"
      :base="fizicka.radno_vrijeme"
    ></form-input>
    <!-- *** OPIS **** -->
    <form-textarea
      :label="$t('forms.person.phys_pers.opis_lbl')"
      id="opis"
      ref="opis"
      :base="fizicka.opis"
    ></form-textarea>

    <v-dialog v-model="remove_user_screen" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t('components.person.physical_person.confirm_user_removal') }}
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div class="universal-vdialog-button vbutton-secondary" @click="cancelUserDeactivation()">{{ $t('components.person.physical_person.cancel') }}</div>
          <div class="universal-vdialog-button vbutton-primary" @click="remove_user_screen = false"> {{ $t('components.person.physical_person.remove') }} </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import formInput from "@/components/formElements/formInput.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import adresaElement from "@/components/formElements/adresaElement.vue";
import formAutocompleteSingle from "@/components/formElements/formAutocompleteSingle.vue";
import formInputMultiple from "@/components/formElements/formInputMultiple.vue";
import osobe from "@/apiCallers/promise_handler_db/osobe_pr";
import formCheckbox from "@/components/formElements/formCheckbox.vue";

import $ from "jquery";

export default {
  data() {
    return {
      refresh_key: 1,
      fizicka: {
        ime: "",
        prezime: "",
        username: "",
        oib: "",
        email_list: [],
        tel_br_list: [],
        adrese_list: [],
        web_list: [],
        industrija_id: { ID: 1 },
        god_prihod: "",
        id_tip_izvora: { ID: 5 },
        izvor_osoba: "",
        multiple_izvori: [],
        custom_ime_izvora: "",
        radno_vrijeme: "",
        opis: "",
        rodjendan: "",
        lead: "",
        eot : "",
      },
      existing_usernames: [],
      listen_user_portal_create: false,
      user_portal_create: { value: false },
      remove_user_screen:false,
      bypass_user_portal: false,
    };
  },
  async created() {
    let route_name = this.$router.history.current.name;
    if (route_name === "PhisicalPersonEdit") {
      console.log(this.$router.history.current.params.oib);
      await osobe
        .getEditPhisEntity(this.$router.history.current.params.oib)
        .then(async (resp) => {
          const fiz_temp = resp.data.osoba;
          this.existing_usernames = resp.data.unavailable_usernames.filter(
            (user) => user != fiz_temp.username
          );

          this.$refs.userPortalBool.$data.value = fiz_temp.username != null && fiz_temp.username != "" ? true : false;

          this.listen_user_portal_create = true;

          this.$refs.usernameFiz.$data.value = fiz_temp.username;

          this.$refs.imeFiz.$data.value =
            fiz_temp.ime == null ? "" : fiz_temp.ime;
          this.$refs.prezimeFiz.$data.value =
            fiz_temp.prezime == null ? "" : fiz_temp.prezime;
          this.$refs.OIB.$data.value = fiz_temp.oib == null ? "" : fiz_temp.oib;
          this.$refs.industrija.$data.ID = fiz_temp.industrija_id;
          this.$refs.godisnjiPrihod.$data.value =
            fiz_temp.god_prihod == null ? "" : fiz_temp.god_prihod;
          this.$refs.tipIzvor.$data.ID = fiz_temp.id_tip_izvora;
          this.$refs.adresaElement.$data.lista_adresa =
            fiz_temp.adresa == null ? [] : fiz_temp.adresa;
            this.fizicka.eot =
            fiz_temp.client_portal_user_remove_access == null
              ? ""
              : new Date(fiz_temp.client_portal_user_remove_access.eot).toISOString().substr(0, 10);

          this.$refs.email.$data.values = fiz_temp.email_list;
          this.$refs.telefon.$data.values = fiz_temp.tel_br_list;
          this.$refs.stranica.$data.values = fiz_temp.web_list;
          this.$refs.customIzvor.$data.value =
            fiz_temp.custom_ime_izvora == null
              ? ""
              : fiz_temp.custom_ime_izvora;
          this.$refs.radnoVrijeme.$data.value =
            fiz_temp.radno_vrijeme == null ? "" : fiz_temp.radno_vrijeme;
          this.$refs.opis.$data.value =
            fiz_temp.opis == null ? "" : fiz_temp.opis;

          this.fizicka.rodjendan =
            fiz_temp.rodjendan == null
              ? ""
              : new Date(fiz_temp.rodjendan).toISOString().substr(0, 10);
          switch (fiz_temp.id_tip_izvora) {
            case 1:
              this.$refs.imeIzvora.$data.results_final.uid =
                fiz_temp.fizicka_osoba.uid;
              this.$refs.imeIzvora.$data.results_final.name =
                fiz_temp.fizicka_osoba.ime +
                " " +
                fiz_temp.fizicka_osoba.prezime;
              break;
            case 2:
              this.$refs.imeIzvora.$data.results_final.uid =
                fiz_temp.pravna_osoba_fizicka_osoba_src_leg_uidTopravna_osoba.uid;
              this.$refs.imeIzvora.$data.results_final.name =
                fiz_temp.pravna_osoba_fizicka_osoba_src_leg_uidTopravna_osoba.ime;
              break;
            case 3:
              fiz_temp.fizicke_odvjetnici_src.forEach((odvj) => {
                this.$refs.clanoviTima.$data.results_final.push({
                  UID: odvj.odvjetnik.uid,
                  is_fiz: true,
                  name: odvj.odvjetnik.ime + " " + odvj.odvjetnik.prezime,
                  status_ID: 1,
                });
                setTimeout(() => {
                  this.$emit(
                    "update:clanovi",
                    this.clanovi.filter((fiz) => fiz.link != odvj.odvjetnik.uid)
                  );
                }, 100);
              });
              break;
            default:
              break;
          }
          this.$emit("finished");
        });
    }
  },
  watch: {
    user_portal_create:{
      handler(newValue) {
        if(this.listen_user_portal_create && (newValue.value == false)){
          console.log("User portal create changed")
          this.remove_user_screen = true;
        }
      },
      deep: true

    //  }
    },
  },
  mounted() {
    this.$refs.tipIzvor.$data.ID = 5;
    this.fizicka.ime = this.$refs.imeFiz.$data;
    this.fizicka.prezime = this.$refs.prezimeFiz.$data;
    this.fizicka.oib = this.$refs.OIB.$data;
    this.fizicka.industrija_id = this.$refs.industrija.$data;
    this.fizicka.god_prihod = this.$refs.godisnjiPrihod.$data;
    this.fizicka.id_tip_izvora = this.$refs.tipIzvor.$data;
    this.fizicka.adrese_list = this.$refs.adresaElement.$data;
    this.fizicka.izvor_osoba = this.$refs.imeIzvora.$data;
    this.fizicka.multiple_izvori = this.$refs.clanoviTima.$data;
    this.fizicka.email_list = this.$refs.email.$data;
    this.fizicka.tel_br_list = this.$refs.telefon.$data;
    this.fizicka.web_list = this.$refs.stranica.$data;
    this.fizicka.custom_ime_izvora = this.$refs.customIzvor.$data;
    this.fizicka.radno_vrijeme = this.$refs.radnoVrijeme.$data;
    this.fizicka.opis = this.$refs.opis.$data;
    this.fizicka.rodjendan = this.$refs.datumRodjenja.value;
    // this.fizicka.lead = this.$refs.teamLead.$data;
    this.user_portal_create = this.$refs.userPortalBool.$data;
    this.fizicka.username = this.$refs.usernameFiz.$data;
    this.fizicka.eot = this.$refs.datumEot.value;
  },
  methods : {
    cancelUserDeactivation(){
      this.user_portal_create.value = true;
      this.remove_user_screen = false;  
    }
  },

  props: [
    "industrija",
    "tipovi_izvora",
    "fizicke",
    "clanovi",
    "pravne",
    "invalid_elements",
    "crm",
  ],
  components: {
    "form-input": formInput,
    "form-textarea": formTextarea,
    "form-drop-down": formDropDown,
    "form-autocomplete": formAutocomplete,
    "adresa-element": adresaElement,
    "form-autocomplete-single": formAutocompleteSingle,
    "form-input-multiple": formInputMultiple,
    "form-checkbox": formCheckbox,
  },
};
</script>
